import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса службы синхронизации (`Sync.Contracts/Routes.cs`, ADR-23). Шаблон создания цели служба синхронизации читает у службы вида сама
 * (RP-SYN5) — клиент о виде источника не знает. Литерал `/api/` законен только в файлах `api/urls.ts` (eslint).
 */
const BASE = '/api/sync/v1'

export const SYNC_URLS = {
  summary: `${BASE}/sources/summary`,
  divergences: `${BASE}/divergences`,
  divergenceCount: `${BASE}/divergences/count`,
  apply: `${BASE}/apply`,
  applyJob: (jobId: string) => `${BASE}/apply-jobs/${encodeURIComponent(jobId)}`,
  /** Повтор неудавшихся строк задачи новой задачей. */
  applyJobRetry: (jobId: string) => `${BASE}/apply-jobs/${encodeURIComponent(jobId)}/retry`,
  ignores: `${BASE}/ignores`,
  ignore: (id: number) => `${BASE}/ignores/${id}`,
  init: (resourceId: string) => `${BASE}/init/${ridSegment(resourceId)}`,
  priceTypeMaps: `${BASE}/price-type-maps`,
  priceVatRules: `${BASE}/price-vat-rules`,
  check: (resourceId: string) => `${BASE}/checks/${ridSegment(resourceId)}`,
  schedule: `${BASE}/schedule`,
  journal: `${BASE}/journal`,
  /** Кадр фото стороны из строки расхождения (у общего каталога ключ записи — общий товар): человек видит фото, прежде чем решить. */
  photo: (resourceId: string, sha256: string, remoteKey: string) =>
    `${BASE}/photos/${ridSegment(resourceId)}/${encodeURIComponent(sha256)}?key=${encodeURIComponent(remoteKey)}`,
  /** Шаблон создания целевого источника — через службу синхронизации (поля и умолчания службы вида как есть). */
  createTemplate: (resourceId: string) => `${BASE}/create-template/${ridSegment(resourceId)}`,
} as const
